module.exports = "/images/role-marketer-icon.svg?1c50d32731dea035880627f767b56a27";